import {
  faFolder,
  faFolderOpen,
  faSort,
  faSortUp,
  faSortDown,
  faUserLock,
  faFile,
  faCircleCheck,
  faCircleExclamation,
  faCircleXmark,
  faCreditCard,
} from '@awesome.me/kit-da13514c94/icons/duotone/solid'

export const duotoneLibrary = [
  faFolder,
  faFolderOpen,
  faSort,
  faSortUp,
  faSortDown,
  faUserLock,
  faFile,
  faCircleCheck,
  faCircleExclamation,
  faCircleXmark,
  faCreditCard,
]
